export class AccessibleHelper {

  private static modules: { [prop: string]: any } = localStorage.getItem('modules') ? JSON.parse(localStorage.getItem('modules')) : {};
  private static navigations: { [prop: string]: any } = localStorage.getItem('navigations') ? JSON.parse(localStorage.getItem('navigations')) : [''];


  public static canActive(key: string) {
    return this.modules[key];
  }
  public static getFuncs(key: string) {
    let jsonString: string = localStorage.getItem(key);
    if (jsonString !== null)
      return JSON.parse(jsonString);
    return {};
  }
  public static getDetautPath(): string {
    return this.navigations[0];
  }
}
export const getUserDefault = () => {
  const userStr = localStorage.getItem('user');
  if (userStr === null) return false;

  return JSON.parse(userStr);
}
export const getAccessByRole = (key: string) => {
  const userStr = localStorage.getItem('user');
  if (userStr === null) return false;

  return JSON.parse(userStr).type === key;
}



// WEBPACK FOOTER //
// ./src/utils/Accessible.util.ts